/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@micromag/core/components';
import { useDocumentEvent } from '@micromag/core/hooks';

const propTypes = {
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    dropdown: PropTypes.node,
    children: PropTypes.node,
    iconOnly: PropTypes.bool,
};

const defaultProps = {
    className: null,
    buttonClassName: null,
    dropdown: null,
    children: null,
    iconOnly: false,
};

const SettingsButton = ({ className, dropdown, children, iconOnly, buttonClassName, ...props }) => {
    const withDropdown = dropdown !== null;
    const [opened, setOpened] = useState(false);
    const onClick = useCallback(() => setOpened(!opened), [opened, setOpened]);
    const refContainer = useRef(null);
    const onDocumentClick = useCallback(
        (e) => {
            if (refContainer.current && !refContainer.current.contains(e.currentTarget)) {
                setOpened(false);
            }
        },
        [refContainer.current, setOpened],
    );
    useDocumentEvent('click', onDocumentClick, withDropdown && opened);

    const button = (
        <Button
            theme="secondary"
            outline
            icon={iconOnly ? <FontAwesomeIcon icon={faCog} color="currentColor" /> : null}
            onClick={onClick}
            className={classNames(
                {
                    [className]: className !== null && !withDropdown,
                    [buttonClassName]: buttonClassName !== null,
                },
            )}
            {...props}
        >
            {iconOnly ? (
                children
            ) : (
                <span className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faCog} color="currentColor" />
                    <span className="d-none d-sm-block ms-2">
                        <FormattedMessage defaultMessage="Settings" description="Button label" />
                    </span>
                </span>
            )}
        </Button>
    );
    return withDropdown ? (
        <div
            className={classNames([
                'dropdown',
                {
                    [className]: className !== null,
                },
            ])}
            ref={refContainer}
        >
            {button}
            {React.cloneElement(dropdown, {
                opened,
            })}
        </div>
    ) : (
        button
    );
};

SettingsButton.propTypes = propTypes;
SettingsButton.defaultProps = defaultProps;

export default SettingsButton;
